<template>
  <div class="border border-grey-light mb-8 p-4 bg-grey-lighter text-sm leading-normal">
    <h3 class="font-semibold mb-6 pb-4 border-b"><i class="fas fa-truck mr-2 text-lg text-print-order-teal" /> Delivery Address</h3>
    <div v-if="! requiresDeliveryAddress">
      <p class="text-xs mb-4">This item will be delivered digitally and does not require a physical delivery address.</p>
    </div>
    <div v-else-if="editable">
      <p class="text-xs mb-4">The delivery address can be changed if the order has not yet been shipped.</p>
      <delivery-address-list @change="updateDeliveryAddress" @updateAddress="updateDeliveryAddress" :narrow="true" :value="deliveryAddressId" :deliveryAddresses="deliveryAddresses" :updatingItem="updatingItem" />
    </div>
    <div v-else>
      <p class="mb-4">{{ deliveryAddress }}</p>
      <p class="text-xs mb-4">The delivery address can no longer be changed for this order.</p>
    </div>
  </div>
</template>

<script>
import DeliveryAddressList from '@/components/DeliveryAddressList'
export default {
  components: { DeliveryAddressList },
  data () {
    return {
      addressModalOpen: false
    }
  },
  props: ['deliveryAddressId', 'deliveryAddress', 'deliveryAddresses', 'requiresDeliveryAddress', 'editable', 'updatingItem'],
  created () {
  },
  methods: {
    updateDeliveryAddress ($event) {
      this.$emit('updateAddress', $event)
    }
  }
}
</script>
